export default __webpack_public_path__ + "static/media/vocalnet3.eb98277b.mp4";